/**
 * AI 계정 로그인 대기 폴링의 **다음 걸음** — 설정 › AI 에이전트(`AssistantSettingsSection`)가 쓴다 (2026-09-14).
 *
 * Codex 디바이스 인증처럼 코드를 되돌려주지 않는 흐름은 화면이 3초마다 계정 상태를 물어 승인 완료를 기다린다.
 * 전에는 로그인 완료·실패·대기 없음 세 응답에서만 멈추고 **요청 실패는 조용히 넘겼다.** 대기 중에 LiveSQL
 * 로그인(QBase 세션)이 끊기자 401 을 받으면서도 3초마다 영원히 불렀고, 백엔드가 요청마다 QBase 에 세션을
 * 확인하느라 QBase 성능관리의 에러 트레이스가 이 요청으로 가득 찼다(최근 500건 전부, 신고 2026-09-14).
 *
 * 멈추는 조건:
 *   · 401 — LiveSQL 로그인이 끊겼다. 다시 물어도 풀리지 않는다(다시 로그인해야 한다)
 *   · 그 밖의 실패가 연달아 LOGIN_POLL_MAX_FAILURES 번 — 서버가 계속 못 답하면 물어도 소용없다
 *   · LOGIN_WAIT_MAX_MS 가 지남 — 디바이스 인증을 포기한 채 탭을 열어 두는 경우
 * 판정만 하는 순수 함수라 화면 없이 시험한다(컴포넌트는 공유 패키지를 불러 jest 에서 못 띄운다).
 */

export const LOGIN_POLL_MS = 3000;
export const LOGIN_POLL_MAX_FAILURES = 5;
export const LOGIN_WAIT_MAX_MS = 10 * 60 * 1000;

/**
 * @param account   이번에 받은 계정 상태 (실패했으면 null)
 * @param error     이번 요청의 오류 (성공했으면 null). `status` 를 본다(assistantClient 가 채운다)
 * @param failures  지금까지 연달아 실패한 횟수
 * @param startedAt 대기를 시작한 시각(ms)
 * @returns {{ action: 'continue'|'done'|'failed'|'gone'|'sessionExpired'|'timeout'|'errors', failures: number }}
 */
export function loginPollStep({ account = null, error = null, failures = 0, startedAt, now = Date.now() } = {}) {
    if (error && error.status === 401) return { action: 'sessionExpired', failures };
    if (!error) {
        if (account && account.loggedIn) return { action: 'done', failures: 0 };
        const pending = account && account.pendingLogin;
        if (pending && pending.state === 'failed') return { action: 'failed', failures: 0 };
        if (!pending) return { action: 'gone', failures: 0 };
    }
    if (Number.isFinite(startedAt) && now - startedAt >= LOGIN_WAIT_MAX_MS) return { action: 'timeout', failures };
    if (error) {
        const next = failures + 1;
        return { action: next >= LOGIN_POLL_MAX_FAILURES ? 'errors' : 'continue', failures: next };
    }
    return { action: 'continue', failures: 0 };
}
